import React from 'react';
import useResizeObserver from '@react-hook/resize-observer';

const useSize = (targetRef) => {
  const [size, setSize] = React.useState();

  React.useLayoutEffect(() => {
    targetRef && setSize(targetRef?.current?.getBoundingClientRect());
  }, [targetRef]);

  useResizeObserver(targetRef, (entry) => {
    setSize(entry.contentRect);
  });

  return size;
};

export default useSize;
